import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'
import { Link } from 'gatsby'


class AboutTwo extends React.Component {

  shouldComponentUpdate() {
    return false
  }
  

    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;
            .particles {
                position: absolute;
                width: 100%;
                height: 100%;
            }
        `

        const AboutCol = styled(Col)`
            display: flex;
            align-items: center;
        `

        const ImageCol = styled(Col)`
            display: flex;
            align-items: center;
            justify-content: center;
            @media (max-width: 767px) {
              padding-top: 30px;
              .image-col {
                  text-align: center;                  
              }
          }
        `
        
        const ImageWrapper = styled.div`
            text-align: center;
      img {
        max-height: 500px;
        max-width: 500px;
        width: 100%;
        height: auto;
      }      
      @media (max-width: 767px) {
        width: 100%;          /* Ocupar todo el ancho de la pantalla */                    
        padding: 0;
        margin: 40px 0;            
        img {
          max-width: 100%;     /* Permitir que la imagen se estire a lo ancho */
          width: 100vw;        /* Igual que el viewport */
          height: auto;
          display: block;       /* Asegura que no tenga espacio extra por inline */          
        }        
      }
    `

        const Main = styled.div`
            padding: 270px 0 150px 0;
            background-color: #fff;
            @media (max-width: 767px) {
                padding: 100px 0;
            }
            @media (min-width: 768px) and (max-width: 1500px) {
                padding: 100px 0;
            }
            @media (min-width: 1501px) and (max-width: 1600px) {
                padding: 150px 0;
            }
        `       

        const Heading2 = styled.h2`
            font-size: 60px;
            line-height: 70px;
            font-family: "Montserrat", sans-serif;
            color: #1b2a2f;
            font-weight: bold;
            text-transform: uppercase;
            @media (min-width:768px) and (max-width:1600px) {
                font-size: 60px;
                line-height: 70px;
            }
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 30px;
                text-align: left;
            }
        `

        const Heading3 = styled.h3`
        font-size: 50px;
        line-height: 60px;
        font-family: "Montserrat", sans-serif;        
        font-weight: bold;        
        @media (min-width:768px) and (max-width:5000px) {
          font-size: 40px;
          line-height: 50px;
        }
        @media (max-width:767px) {
          font-size: 30px;
          line-height: 30px;
          text-align: left;
        }
        @media (min-width:5001px) and (max-width:1600px) {
          font-size: 40px;
          line-height: 50px;
          margin-top: 50px;
        }
        `

        const Color = styled.span`
            color: #a3ff00;
            font-size: 75px;
            line-height: 70px;
            font-family: Teko;
            text-transform: uppercase;
            letter-spacing: 2px;
            @media (min-width:768px) and (max-width:1600px) {
                font-size: 80px;
                line-height: 40px;
            }
            @media (max-width:767px) {
                font-size: 40px;
                line-height: 40px;
            }
        `
        
        const AboutContent = styled.div`
            padding: 0 20%;
            @media (max-width: 500px) {
                padding: 0 5%;
            }
            @media (min-width: 501px) and (max-width:1600px) {
                padding: 0 5%;
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #a3ff00;
            margin-bottom: 20px;
        `

        const Text = styled.p`
          font-size: 18px;
          line-height: 26px;      
          font-weight: 300;
          color: #1a1a1a;
      ` 

        const Headinga = styled(Link)`        
        color: #78c91c;
        transition: .5s;
          &:hover {
          color: #000;
          text-decoration: none;
        }
      `

      const HeadingaSpan = styled(Link)`        
        color: #78c91c;
        transition: .5s;
          &:hover {
            color: #000;
            text-decoration: none;
          }
      `

        return(
            <Section id="devweb">
                <Main>
                    <Row>
                        <AboutCol md={6}>
                            <Col md={12}>
                                
                                    <AboutContent>
                                        <Heading2>
                                            Desarrollo <Color>Web</Color>
                                        </Heading2>
                                        <Separator />
                                        <Text>
                                            ¿Buscas soluciones web adaptadas a tus necesidades específicas?
                                        </Text>
                                        <Text>
                                            Nuestro enfoque se centra en el desarrollo de software a la medida para plataformas en la Nube.
                                            Creamos aplicaciones web utilizando tecnologías de vanguardia, tales como <HeadingaSpan to="/desarrollo-de-software"><strong>HTML5</strong></HeadingaSpan>, <HeadingaSpan to="/desarrollo-de-software"><strong>ReactJS</strong></HeadingaSpan>, <HeadingaSpan to="/desarrollo-de-software"><strong>ASP.NET</strong></HeadingaSpan> y <HeadingaSpan to="/desarrollo-de-software"><strong>Node JS</strong></HeadingaSpan>. Además,
                                            implementamos prácticas de desarrollo ágil y seguridad integrada, abarcando los principios de <HeadingaSpan to="/desarrollo-de-software"><strong>DevOps</strong></HeadingaSpan> y <HeadingaSpan to="/desarrollo-de-software"><strong>DevSecOps</strong></HeadingaSpan>.
                                        </Text>
                                        <Heading3>
                                            <Headinga to="/desarrollo-de-software">
                                                Software a la medida
                                            </Headinga>
                                        </Heading3>
                                    </AboutContent>
                                
                            </Col>
                        </AboutCol>
                        <ImageCol md={6}>
                            <ImageWrapper>
                                
                                    <GatsbyImage image={this.props.image} alt="Desarrollo de Software a la medida en Colombia" sizes="(max-width: 767px) 300px, 500px" />
                                
                            </ImageWrapper>
                        </ImageCol>
                    </Row>
                </Main>
            </Section>
        )
    }

}

const Iconos = (props) => (
    <StaticQuery
      query={graphql`
        {
          file(relativePath: { eq: "desarrollo-de-software.jpg" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 500
              )
            }
          }
        }
      `}
      render={(data) => {
        const image = getImage(data.file.childImageSharp.gatsbyImageData);
        return <AboutTwo image={image} {...props} />;
      }}
    />
  );
  
  export default Iconos;
